module.exports = __webpack_public_path__ + "static/media/focus-area-icon.8798f388.svg";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/assets/images/focus-area-icon.svg
// module id = 1782
// module chunks = 27